<template>
    <div class="send-join-email-check-invites-container">
        <div v-if="showSuccessIcon">
            <img class="notification-icon" :src="loadSuccessIcon" />
        </div>
        <div v-else-if="showErrorIcon">
            <img class="notification-icon" :src="loadErrorIcon" />
        </div>
        <p class="header">
            {{
                $t('modals.send_join_invites_modal_check_emails.heading', {
                    newInvites: newInvitesCount,
                    totalInvites: totalCount,
                })
            }}
        </p>
        <p v-if="invitedCount > 0" class="sub-header">
            <span v-if="invitedCount > 1">
                {{ $t('modals.send_join_invites_modal_check_emails.sub_header_invitations_plural', { count: invitedCount }) }}
            </span>
            <span v-else>
                {{ $t('modals.send_join_invites_modal_check_emails.sub_header_invitations', { count: invitedCount }) }}
            </span>
        </p>
        <p v-if="registeredInvitesCount > 0 || registeredCount > 0" class="sub-header">
            <span v-if="registeredInvitesCount + registeredCount > 1">
                {{
                    $t('modals.send_join_invites_modal_check_emails.sub_header_members_plural', {
                        count: registeredInvitesCount + registeredCount,
                    })
                }}
            </span>
            <span v-else>
                {{
                    $t('modals.send_join_invites_modal_check_emails.sub_header_members', {
                        count: registeredInvitesCount + registeredCount,
                    })
                }}
            </span>
        </p>
        <p v-if="registrationNotCompletedCount > 0" class="sub-header">
            <span v-if="registrationNotCompletedCount > 1">
                {{
                    $t('modals.send_join_invites_modal_check_emails.sub_header_registration_not_completed_plural', {
                        count: registrationNotCompletedCount,
                    })
                }}
            </span>
            <span v-else>
                {{
                    $t('modals.send_join_invites_modal_check_emails.sub_header_registration_not_completed', {
                        count: registrationNotCompletedCount,
                    })
                }}
            </span>
        </p>
        <div v-if="showContent" class="content">
            <common-content-group v-if="memberUsers.length > 0" :isCompact="true">
                <p class="group-header">
                    {{ $t('modals.send_join_invites_modal_check_emails.users_list_members_header') }}
                </p>
                <ul class="connections-widget__list list">
                    <li v-for="(memberUser, index) in memberUsers" :key="index" class="connections-widget__item item">
                        <article class="connections-item nested-item">
                            <div class="connections-item__avatar">
                                <common-user-avatar :user="memberUser" size="member-switch"></common-user-avatar>

                                <div class="connections-item__type">
                                    <common-icon :name="getIconName(memberUser)" size="huge"></common-icon>
                                </div>
                            </div>

                            <h4 class="connections-item__name">
                                <common-user-name :user="memberUser"></common-user-name>
                            </h4>

                            <p class="connections-item__role">
                                {{ getUserRoleName(memberUser) }}
                            </p>
                        </article>
                    </li>
                </ul>
            </common-content-group>
            <common-content-group v-if="registrationNotCompletedUsers.length > 0" :isCompact="true">
                <p class="group-header">
                    {{ $t('modals.send_join_invites_modal_check_emails.users_list_registration_not_completed_header') }}
                </p>
                <ul class="connections-widget__list list">
                    <li
                        v-for="(registrationNotCompletedUser, index) in registrationNotCompletedUsers"
                        :key="index"
                        class="connections-widget__item item"
                    >
                        <article class="connections-item nested-item">
                            <div class="connections-item__avatar">
                                <common-user-avatar
                                    :user="registrationNotCompletedUser"
                                    size="member-switch"
                                    :isUserProfileLinkEnabled="false"
                                ></common-user-avatar>

                                <div class="connections-item__type">
                                    <common-icon :name="getIconName(registrationNotCompletedUser)" size="huge"></common-icon>
                                </div>
                            </div>

                            <h4 class="connections-item__name">
                                <common-user-name :user="registrationNotCompletedUser"></common-user-name>
                            </h4>

                            <p class="connections-item__role">
                                {{ getUserRoleName(registrationNotCompletedUser) }}
                            </p>
                        </article>
                    </li>
                </ul>
            </common-content-group>
            <common-content-group v-if="invitedUsers.length > 0" :isCompact="false">
                <ul class="connections-widget__list list">
                    <li v-for="(invitedUser, index) in invitedUsers" :key="index" class="connections-widget__item item">
                        <article class="connections-item nested-item">
                            <div class="connections-item__avatar">
                                <common-user-avatar
                                    :user="invitedUser"
                                    size="member-switch"
                                    :isUserProfileLinkEnabled="false"
                                ></common-user-avatar>

                                <div class="connections-item__type">
                                    <common-icon :name="getIconName(invitedUser)" size="huge"></common-icon>
                                </div>
                            </div>

                            <h4 class="connections-item__name">
                                <common-user-name :user="invitedUser"></common-user-name>
                            </h4>

                            <p class="connections-item__role">
                                {{ getUserRoleName(invitedUser) }}
                            </p>
                        </article>
                    </li>
                </ul>
            </common-content-group>
        </div>
        <common-button
            v-if="defaultCloseButtonEnabled"
            :label="$t('modals.send_join_invites_modal_check_emails.close_button')"
            type="primary"
            size="large"
            :isSubmittable="false"
            @click="emitEvent({ name: 'close' })"
        ></common-button>
        <div v-else-if="!defaultCloseButtonEnabled && innerButtonsProperties.length > 0" class="additional-buttons">
            <common-button
                v-for="(props, index) in innerButtonsProperties"
                :key="index"
                class="additional-button"
                :label="props.label"
                :type="props.type"
                :isSubmittable="props.isSubmittable"
                :size="props.size"
                @click="emitEvent({ name: props.eventName })"
            ></common-button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            defaultCloseButtonEnabled: { type: Boolean, required: false, default: true },
            emailsCheck: {
                type: Object,
                required: true,
                default() {
                    return {
                        invited: [],
                        registeredInvites: [],
                        registeredOther: [],
                        newInvitations: [],
                        registrationNotCompleted: [],
                    }
                },
            },
            practiceType: { type: String, default: null },
            innerButtonsProperties: { type: Array, required: false, default: () => [] },
        },

        data() {
            return {
                invitedUsers: [],
                memberUsers: [],
                registrationNotCompletedUsers: [],
                showSuccessIcon: false,
                showErrorIcon: false,
                invitedCount: 0,
                registeredInvitesCount: 0,
                registeredCount: 0,
                newInvitesCount: 0,
                registrationNotCompletedCount: 0,
                totalCount: 0,
            }
        },

        computed: {
            loadSuccessIcon: function () {
                return require('../../../images/sucess-icon.svg').default
            },
            loadErrorIcon: function () {
                return require('../../../images/error-icon.svg').default
            },

            showContent() {
                return (
                    this.memberUsers.length > 0 || this.registrationNotCompletedUsers.length > 0 || this.invitedUsers.length > 0
                )
            },
        },

        methods: {
            getIconName(user) {
                if (user.practiceType) {
                    return user.practiceType === 2 ? 'member' : 'colleague'
                }
                return ''
            },
            getUserRoleName(user) {
                if (user.practiceType) {
                    return user.practiceType === 2
                        ? this.$t('modals.send_join_invites_modal_check_emails.physician')
                        : this.$t('modals.send_join_invites_modal_check_emails.ancillary')
                }
                return ''
            },
        },

        beforeMount() {
            if (this.emailsCheck.newInvitations && this.emailsCheck.newInvitations.length) {
                this.showSuccessIcon = true
                this.newInvitesCount = this.emailsCheck.newInvitations.length
                this.$emit('new-email-invitations-present', { emails: this.emailsCheck.newInvitations })
            } else {
                this.showErrorIcon = true
            }
            if (this.emailsCheck.invited && this.emailsCheck.invited.length) {
                this.invitedCount = this.emailsCheck.invited.length
                this.emailsCheck.invited.forEach((invite) =>
                    this.invitedUsers.push({
                        connectionType: invite.connectionType,
                        name: invite.email,
                        practiceType: !invite.practiceType ? '' : invite.practiceType === 'physician' ? 2 : 3,
                        avatar: invite.avatar,
                        target: {
                            name: invite.email,
                        },
                    }),
                )
            }
            if (this.emailsCheck.registeredInvites && this.emailsCheck.registeredInvites.length) {
                this.registeredInvitesCount = this.emailsCheck.registeredInvites.length
                this.emailsCheck.registeredInvites.forEach((invite) =>
                    this.memberUsers.push({
                        firstName: invite.firstName,
                        lastName: invite.lastName,
                        connectionType: invite.connectionType,
                        name: invite.email,
                        practiceType: !invite.practiceType ? '' : invite.practiceType === 'physician' ? 2 : 3,
                        avatar: invite.avatar,
                    }),
                )
            }
            if (this.emailsCheck.registeredOther && this.emailsCheck.registeredOther.length) {
                this.registeredCount = this.emailsCheck.registeredOther.length
                this.emailsCheck.registeredOther.forEach((invite) =>
                    this.memberUsers.push({
                        firstName: invite.firstName,
                        lastName: invite.lastName,
                        connectionType: invite.connectionType,
                        name: invite.email,
                        practiceType: !invite.practiceType ? '' : invite.practiceType === 'physician' ? 2 : 3,
                        avatar: invite.avatar,
                    }),
                )
            }
            if (this.emailsCheck.registrationNotCompleted && this.emailsCheck.registrationNotCompleted.length) {
                this.registrationNotCompletedCount = this.emailsCheck.registrationNotCompleted.length
                this.emailsCheck.registrationNotCompleted.forEach((invite) =>
                    this.registrationNotCompletedUsers.push({
                        firstName: invite.firstName,
                        lastName: invite.lastName,
                        connectionType: invite.connectionType,
                        name: invite.email,
                        practiceType: !invite.practiceType ? '' : invite.practiceType === 'physician' ? 2 : 3,
                        avatar: invite.avatar,
                    }),
                )
            }
            this.totalCount =
                this.newInvitesCount +
                this.invitedCount +
                this.registeredInvitesCount +
                this.registeredCount +
                this.registrationNotCompletedCount
        },
    }
</script>

<style scoped>
    .send-join-email-check-invites-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .send-join-email-check-invites-container .notification-icon {
        height: 50px;
        width: 50px;
        margin-bottom: 1.125rem;
    }

    .send-join-email-check-invites-container > .header {
        font-size: 26px;
        font-weight: bold;
        line-height: 1.875rem;
        margin-bottom: 0.625rem;
        padding: 0 1.875rem;
        text-align: center;
    }
    .send-join-email-check-invites-container > .sub-header {
        color: #333333;
        font-family: Poppins;
        font-size: 18px;
        line-height: 1.875rem;
        margin-bottom: 1.25rem;
        text-align: center;
    }

    .send-join-email-check-invites-container .content {
        height: 340px;
        width: 100%;
        background-color: #f9f9f9;
        margin-bottom: 23px;
        overflow-y: auto;
    }

    .send-join-email-check-invites-container .content .group-header {
        color: #666666;
        font-family: Poppins;
        font-size: 12px;
        letter-spacing: 0.011875rem;
        line-height: 1.125rem;
        text-align: center;
        margin-bottom: 1.25rem;
    }

    .send-join-email-check-invites-container .content .list {
        display: flex;
        margin: 0;
        flex-wrap: wrap;
        justify-content: center;
    }

    .send-join-email-check-invites-container .content .item {
        width: calc(100% / 3);
        padding: 1em;
        margin: 0;
    }

    .send-join-email-check-invites-container .content .nested-item {
        cursor: default;
    }

    .send-join-email-check-invites-container .additional-buttons {
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .send-join-email-check-invites-container .additional-buttons .additional-button {
        margin: 1em;
        height: 3.125rem;
        min-width: 12.125rem;
        width: auto;
    }
</style>
